var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"totop",class:{ show: _vm.isShow }},[_c('a',{staticClass:"link",on:{"click":function($event){return _vm.toHead()}}},[_c('img',{attrs:{"src":require("@/assets/images/icons/up.svg")}})])])}
var staticRenderFns = []

export { render, staticRenderFns }